/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Cabin,
    CabinFromJSON,
    CabinFromJSONTyped,
    CabinToJSON,
} from './';

/**
 * 
 * @export
 * @interface CabinCriteriaResponse
 */
export interface CabinCriteriaResponse {
    /**
     * 
     * @type {Cabin}
     * @memberof CabinCriteriaResponse
     */
    value?: Cabin;
    /**
     * 
     * @type {boolean}
     * @memberof CabinCriteriaResponse
     */
    exclude?: boolean;
}

export function CabinCriteriaResponseFromJSON(json: any): CabinCriteriaResponse {
    return CabinCriteriaResponseFromJSONTyped(json, false);
}

export function CabinCriteriaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinCriteriaResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : CabinFromJSON(json['value']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function CabinCriteriaResponseToJSON(value?: CabinCriteriaResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': CabinToJSON(value.value),
        'exclude': value.exclude,
    };
}


